<script setup lang="ts">
import {
    isNaturalProfileAttributeLocked,
    usePersonalAccountDataState,
} from '../../../../utilities/account/useAccountDataPersonal'
import BaseInputText from '../../../base/BaseInputText.vue'
import { CreditCardIcon } from '@heroicons/vue/solid'
import {
    isNaturalProfileAttributeHidden,
    isRequiredNaturalProfileAttributesForInvestment,
    isRequiredRequiredNaturalProfileAttributes,
} from '../../../../validation'
import { initPersonalAccountForm } from '../../../../utilities/account/useAccountFormPersonal'
import { getIsIbanFromBankAccount } from '../../../../utilities/usePlatformSettings'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { navigateTo } from '../../../../utilities/account/useAccountNavigationPersonal'

const { naturalProfile: account } = usePersonalAccountDataState()

initPersonalAccountForm('Bank Data')

function goToBankVerification() {
    navigateTo('Verification', 'kyc_bank')
}
</script>

<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-8 px-4 py-5 sm:grid-cols-2 sm:px-6">
        <div v-if="!isNaturalProfileAttributeHidden('iban')" class="sm:col-span-1">
            <BaseInputText
                v-model="account.iban"
                :required="isRequiredRequiredNaturalProfileAttributes('iban')"
                :required-2="isRequiredNaturalProfileAttributesForInvestment('iban')"
                :disabled="isNaturalProfileAttributeLocked('iban') || getIsIbanFromBankAccount()"
                :icon="CreditCardIcon"
                name="account.iban"
                :label="$t('account.iban')" />
        </div>
        <div v-if="!isNaturalProfileAttributeHidden('bic')" class="sm:col-span-1">
            <BaseInputText
                v-model="account.bic"
                :icon="CreditCardIcon"
                :required="isRequiredRequiredNaturalProfileAttributes('bic')"
                :required-2="isRequiredNaturalProfileAttributesForInvestment('bic')"
                :disabled="isNaturalProfileAttributeLocked('bic') || getIsIbanFromBankAccount()"
                name="account.bic"
                :label="$t('account.bic')" />
        </div>
    </div>

    <div v-if="getIsIbanFromBankAccount()" class="px-4 py-5 sm:px-6">
        <div class="items-center justify-between space-y-2 md:flex md:space-y-0">
            <p class="max-w-md pt-1 text-xs text-gray-400">
                {{ $t('bank_data.iban_from_bank_account_notice') }}
            </p>
            <BaseButtonMuted size="lg" class="w-full whitespace-nowrap sm:w-auto" @click="goToBankVerification">
                {{ $t('bank_data.iban_from_bank_account_link_button') }}
            </BaseButtonMuted>
        </div>
    </div>
</template>
